<mat-dialog-content style="display: flex; flex-direction: column; align-items: center; background: #ffffff">
  <img src="assets/gifs/meancat-150.gif" alt="no coffee for you" style="width: 300px; height: auto;" />
  <div class="coffee-text" [class.visible]="showText" style="margin-bottom: 24px">
    <h2>Error 404</h2>
    <p class="error-message">{{'COFFEE_ERROR' | translate}}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="display: flex; flex-direction: column; align-items: center; background: #ffffff">
  <button mat-flat-button class="coffee-text" style="margin-bottom: 12px" [class.visible]="showButton1"
          (click)="backToDashboard()" cdkFocusInitial>{{'BACK_TO_WORK' | translate}}</button>
  <button mat-button class="coffee-text" [class.visible]="showButton2"
          (click)="onNoClick()">{{'WHAT_WAS_THE_ERROR' | translate}}</button>
</mat-dialog-actions>
